import { ChartTooltipWrapperProvider } from '@modules/charts/components/ChartTooltipWrapper/ChartTooltipWrapperProvider';
import { QuantifyReportTableActions } from '@modules/quantify/components/QuantifyReportTableActions';
import { Typography } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

interface getActionsColumnParams {
  shouldHideActions?: boolean;
  isCompactTableVariant?: boolean;
  shouldShowAddToFilterForBothCompareFields?: boolean;
  shouldShowMergeWithSelectedReasonsAction?: boolean;
}

export function getActionsColumn({
  shouldHideActions = false,
  isCompactTableVariant = false,
  shouldShowAddToFilterForBothCompareFields,
  shouldShowMergeWithSelectedReasonsAction = true,
}: getActionsColumnParams) {
  const actionsColumn: GridColDef | null = shouldHideActions
    ? null
    : {
        field: 'Action',
        renderHeader: () =>
          isCompactTableVariant ? null : (
            <Typography variant="subtitle2">Actions</Typography>
          ),
        width: isCompactTableVariant ? 30 : 80,
        renderCell: (params) => (
          <ChartTooltipWrapperProvider>
            <QuantifyReportTableActions
              params={params}
              shouldShowActionsOnHover={isCompactTableVariant}
              buttonSize={isCompactTableVariant ? 'small' : undefined}
              shouldShowAddToFilterForBothCompareFields={
                shouldShowAddToFilterForBothCompareFields
              }
              shouldShowMergeWithSelectedReasonsAction={
                shouldShowMergeWithSelectedReasonsAction
              }
            />
          </ChartTooltipWrapperProvider>
        ),
        headerAlign: 'center',
        align: 'center',
        disableColumnMenu: true,
        type: 'actions',
        resizable: false,
      };

  return actionsColumn;
}
